var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import apiClient from './InkyAPI';
import { v4 as uuid } from 'uuid';
import { Cart } from '../Models/Cart';
import { Country } from '../Models/Country';
import { Purchase, } from '../Models/Purchase';
import { PurchaseError } from '../Models/Errors/PurchaseError';
var ApiErrorException = /** @class */ (function (_super) {
    __extends(ApiErrorException, _super);
    function ApiErrorException(message) {
        var _this = _super.call(this, message.message) || this;
        _this.type = message.type;
        _this.name = "ApiErrorException";
        return _this;
    }
    return ApiErrorException;
}(Error));
export { ApiErrorException };
var OrderAPI = /** @class */ (function () {
    function OrderAPI() {
    }
    // @deprecated Use FetchCart in InkyAPI V2
    OrderAPI.prototype.fetchCart = function (cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            var cartId, cart, apiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cartId = OrderAPI.checkForCartId(null);
                        cart = null;
                        apiResponse = apiClient.getResponse('/cart/' + cartId, cancelTokenSource);
                        return [4 /*yield*/, apiResponse.then(function (x) {
                                console.debug("API: Successfully fetched Cart", x);
                                cart = Cart.createFromApi(x.response);
                                if (cartId !== cart.guestId) {
                                    //If the cart ID has been changed, update it.
                                    OrderAPI.setCartId(cart.guestId);
                                }
                                console.debug("Cart is", cart);
                            }).catch(function (e) {
                                console.error("[OrderAPI:fetchCart] API-error:", e);
                                cart = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    OrderAPI.prototype.addProductToCart = function (cart, productId, variantId, isFree, cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            var cartId, apiRequest, apiResponse, newCart, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cartId = OrderAPI.checkForCartId(cart ? cart.id : null);
                        apiRequest = { "productId": productId, "VariantId": variantId, "Amount": 1, "isFree": true };
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, apiClient.patchResponse('/cart/' + cartId, apiRequest)];
                    case 2:
                        apiResponse = _a.sent();
                        console.debug("API: Successfully updated Cart", apiResponse);
                        newCart = Cart.createFromApi(apiResponse.response);
                        console.debug("Updated cart is", cart);
                        if ((newCart === null || newCart === void 0 ? void 0 : newCart.guestId) && (newCart === null || newCart === void 0 ? void 0 : newCart.guestId) !== cartId) {
                            console.log("Cart Guest ID changed from ".concat(cartId, " to ").concat(newCart === null || newCart === void 0 ? void 0 : newCart.guestId, "...."));
                            OrderAPI.setCartId(newCart.guestId);
                        }
                        console.log("NEW CART++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
                        return [2 /*return*/, newCart];
                    case 3:
                        e_1 = _a.sent();
                        console.error("[OrderAPI:addProductToCart] API-error:", e_1);
                        return [2 /*return*/, null];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OrderAPI.prototype.removeProductFromCart = function (cartId, product, variantId, cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            var apiRequest, cart, apiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cartId = OrderAPI.checkForCartId(cartId);
                        apiRequest = { "productId": product.id, "VariantId": variantId, "Amount": -1 };
                        cart = null;
                        apiResponse = apiClient.patchResponse('/cart/' + cartId, apiRequest, cancelTokenSource);
                        return [4 /*yield*/, apiResponse.then(function (x) {
                                console.debug("API: Successfully updated Cart", x);
                                cart = Cart.createFromApi(x.response);
                                if ((cart === null || cart === void 0 ? void 0 : cart.guestId) && (cart === null || cart === void 0 ? void 0 : cart.guestId) !== cartId) {
                                    console.log("Cart Guest ID changed from ".concat(cartId, " to ").concat(cart === null || cart === void 0 ? void 0 : cart.guestId, "...."));
                                    OrderAPI.setCartId(cart.guestId);
                                }
                                console.log("NEW CART++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++");
                                console.debug("Updated cart is", cart);
                            }).catch(function (e) {
                                console.error("[OrderAPI:addProductToCart] API-error:", e);
                                cart = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    OrderAPI.prototype.removeAllOfProductFromCart = function (cartId, product, variantId, cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            var apiRequest, cart, apiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cartId = OrderAPI.checkForCartId(cartId);
                        apiRequest = { "productId": product.id, "VariantId": variantId, "Amount": -1, "RemoveAll": true };
                        cart = null;
                        apiResponse = apiClient.patchResponse('/cart/' + cartId, apiRequest, cancelTokenSource);
                        return [4 /*yield*/, apiResponse.then(function (x) {
                                console.debug("API: Successfully updated Cart", x);
                                cart = Cart.createFromApi(x.response);
                                console.debug("Updated cart is", cart);
                            }).catch(function (e) {
                                console.error("[OrderAPI:addProductToCart] API-error:", e);
                                cart = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    OrderAPI.prototype.clearCart = function (cartId, cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            var cart, apiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cartId = OrderAPI.checkForCartId(cartId);
                        cart = null;
                        apiResponse = apiClient.patchResponse('/cart/' + cartId + '/empty', null, cancelTokenSource);
                        return [4 /*yield*/, apiResponse.then(function (x) {
                                console.debug("API: Successfully updated Cart", x);
                                cart = Cart.createFromApi(x.response);
                                console.debug("Updated cart is", cart);
                            }).catch(function (e) {
                                console.error("[OrderAPI:addProductToCart] API-error:", e);
                                cart = null;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, cart];
                }
            });
        });
    };
    // async getShippingRates(cartId: string, countryCode: string, postalCode: string, cancelTokenSource: CancelTokenSource): Promise<ShippingRate[]> {
    //     const params = [
    //         ["CountryCode", countryCode],
    //         ["ZipCode", postalCode]
    //     ];
    //
    //     let shippingRates = [];
    //     const apiResponse: Promise<ApiModel<ShippingRateDTO[]>> = apiClient.getResponse('/order/shipping/getRatesForCart/' + cartId, cancelTokenSource, params)
    //     await apiResponse.then(x => {
    //         console.debug("API: Successfully received shippingRates", x);
    //         shippingRates = x.response.map(x => ShippingRate.createFromApi(x));
    //         console.debug("Shipping Rates are", shippingRates);
    //     }).catch(e => {
    //         console.error("[OrderAPI:addProductToCart] API-error:", e);
    //         shippingRates = [];
    //     });
    //     return shippingRates;
    //
    //
    // }
    OrderAPI.prototype.getSalesTax = function (countryCode, administrativeArea, cancelTokenSource) {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = [
                            ["CountryCode", countryCode],
                            ["AdministrativeArea", administrativeArea]
                        ];
                        return [4 /*yield*/, apiClient.getResponse('/order/shipping/getSalesTax/', cancelTokenSource, params)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    //endregion
    OrderAPI.checkForCartId = function (cartId) {
        // Of cartId is null, lets try to find it in localstorage.
        if (cartId == null) {
            cartId = localStorage.getItem('browserId');
        }
        // If cartId is still null, lets generate a new one.
        if (cartId == null) {
            cartId = uuid();
            localStorage.setItem('browserId', cartId);
        }
        return cartId;
    };
    /**
     *
     * @param newCartId
     * @private
     */
    OrderAPI.setCartId = function (newCartId) {
        localStorage.setItem('browserId', newCartId);
    };
    //region API-calls
    OrderAPI.prototype.fetchCountries = function (cancelTokenSource) {
        if (cancelTokenSource === void 0) { cancelTokenSource = null; }
        return __awaiter(this, void 0, void 0, function () {
            var apiResponse, countries, sortedList, usa, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.log('Fetch countries for shipping');
                        return [4 /*yield*/, apiClient.getResponse('/order/shippingCountries', cancelTokenSource)];
                    case 1:
                        apiResponse = _b.sent();
                        countries = apiResponse.response.map(function (x) { return Country.createFromApi(x); });
                        sortedList = [];
                        usa = countries.find(function (x) { return x.countryCode === "US"; });
                        _a = usa;
                        return [4 /*yield*/, this.fetchStates(cancelTokenSource)];
                    case 2:
                        _a.states = _b.sent();
                        sortedList.push(usa);
                        // Move Canada to top
                        sortedList.push(countries.find(function (x) { return x.countryCode === "CA"; }));
                        sortedList = sortedList.concat(countries.filter(function (x) { return x.countryCode !== "CA" && x.countryCode !== "US"; }));
                        return [2 /*return*/, sortedList];
                }
            });
        });
    };
    //region API-calls
    OrderAPI.prototype.fetchStates = function (cancelTokenSource) {
        if (cancelTokenSource === void 0) { cancelTokenSource = null; }
        return __awaiter(this, void 0, void 0, function () {
            var apiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiClient.getResponse('/order/shippingStates', cancelTokenSource)];
                    case 1:
                        apiResponse = _a.sent();
                        return [2 /*return*/, apiResponse.response];
                }
            });
        });
    };
    OrderAPI.prototype.fetchPurchaseRequest = function (request, widths, abortSignal) {
        if (widths === void 0) { widths = null; }
        return __awaiter(this, void 0, void 0, function () {
            var params, apiResponse;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = "";
                        if (widths) {
                            params = "?widths=".concat(widths);
                        }
                        return [4 /*yield*/, apiClient.postV4('/purchase-request' + params, request, abortSignal)];
                    case 1:
                        apiResponse = _a.sent();
                        console.log("Purchase request Response!!!:.");
                        console.log(apiResponse);
                        return [2 /*return*/, Purchase.createFromApi(apiResponse.response)];
                }
            });
        });
    };
    OrderAPI.prototype.fetchAddressValidationResponse = function (Request, previousResponseId, abortSignal) {
        return __awaiter(this, void 0, void 0, function () {
            var params, apiResponse, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = '';
                        params = "?previousResponseId=".concat(previousResponseId);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, apiClient.postV4('/verify-address' + params, Request, abortSignal)];
                    case 2:
                        apiResponse = _a.sent();
                        console.log('Address Validation Response!!!:.');
                        console.log(apiResponse);
                        if (apiResponse.status.type === 'Success') {
                            return [2 /*return*/, apiResponse.response];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        console.log('exception thrown...');
                        console.debug('Exception of ', e_2.response.status);
                        console.error(e_2);
                        throw e_2;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OrderAPI.prototype.purchase = function (purchase, cancelTokenSource) {
        if (cancelTokenSource === void 0) { cancelTokenSource = null; }
        return __awaiter(this, void 0, void 0, function () {
            var dto, apiResponse, e_3, responseStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.debug("Initiating Purchasing-request");
                        dto = purchase.toApi();
                        console.log("order/purchase...: dto");
                        console.log(dto);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, apiClient.postResponse('/order/purchase', dto, cancelTokenSource)];
                    case 2:
                        apiResponse = _a.sent();
                        console.log("Response!!!:.");
                        console.log(apiResponse);
                        if (apiResponse.status.type === 'Success') {
                            return [2 /*return*/, Purchase.createFromApi(apiResponse.response)];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_3 = _a.sent();
                        if (e_3.response.status == 400) {
                            responseStatus = e_3.response.data.status;
                            console.debug(responseStatus);
                            throw new ApiErrorException(responseStatus);
                        }
                        console.log("exception thrown...");
                        console.debug("Exception of ", e_3.response.status);
                        console.error(e_3);
                        throw e_3;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OrderAPI.prototype.purchaseGetPaymentIntent = function (purchase, cancelTokenSource) {
        if (cancelTokenSource === void 0) { cancelTokenSource = null; }
        return __awaiter(this, void 0, void 0, function () {
            var dto, apiResponse, e_4, responseStatus;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        console.debug("Initiating Purchasing-request");
                        dto = purchase.toApi();
                        console.log("order/purchase...: dto");
                        console.log(dto);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, apiClient.postResponse('/order/purchase', dto, cancelTokenSource)];
                    case 2:
                        apiResponse = _a.sent();
                        console.log("Response!!!:.");
                        console.log(apiResponse);
                        if (apiResponse.status.type === 'Success') {
                            return [2 /*return*/, apiResponse.response];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_4 = _a.sent();
                        if (e_4.response.status == 400) {
                            responseStatus = e_4.response.data.status;
                            console.debug(responseStatus);
                            throw new ApiErrorException(responseStatus);
                        }
                        console.log("exception thrown...");
                        console.debug("Exception of ", e_4.response.status);
                        console.error(e_4);
                        throw e_4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    OrderAPI.prototype.initiatePurchase = function (purchaseAttempt, cancelTokenSource) {
        if (cancelTokenSource === void 0) { cancelTokenSource = null; }
        return __awaiter(this, void 0, void 0, function () {
            var confirmedPurchase, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.purchase(purchaseAttempt.purchase, cancelTokenSource)];
                    case 1:
                        confirmedPurchase = _a.sent();
                        return [2 /*return*/, Object.assign({}, purchaseAttempt, {
                                purchase: confirmedPurchase
                            })];
                    case 2:
                        e_5 = _a.sent();
                        throw new PurchaseError(e_5.message, purchaseAttempt.purchase);
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    OrderAPI.prototype.confirmPayment = function (paymentResult, cancelTokenSource) {
        if (cancelTokenSource === void 0) { cancelTokenSource = null; }
        return __awaiter(this, void 0, void 0, function () {
            var payload;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            message: paymentResult.message,
                            transactionId: paymentResult.transactionId,
                            purchaseId: paymentResult.purchase.id
                        };
                        return [4 /*yield*/, apiClient.postResponse('/order/purchase-soft-confirmed', payload, cancelTokenSource)];
                    case 1:
                        _a.sent();
                        //await KlaviyoManager.PurchaseEvent(paymentResult.purchase);
                        return [2 /*return*/, paymentResult];
                }
            });
        });
    };
    OrderAPI.prototype.confirmPaymentTransaction = function (paymentResult, cancelTokenSource) {
        if (cancelTokenSource === void 0) { cancelTokenSource = null; }
        return __awaiter(this, void 0, void 0, function () {
            var payload, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payload = {
                            transactionId: paymentResult.transactionId,
                        };
                        return [4 /*yield*/, apiClient.postResponse('/order/payment-soft-confirmed', payload, cancelTokenSource)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.response];
                }
            });
        });
    };
    //purchase-failed
    OrderAPI.prototype.reportPaymentFailure = function (paymentFailure, cancelTokenSource) {
        if (cancelTokenSource === void 0) { cancelTokenSource = null; }
        return __awaiter(this, void 0, void 0, function () {
            var apiPurchaseFailure;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        apiPurchaseFailure = {
                            purchaseId: paymentFailure.purchase.id,
                            message: paymentFailure.message
                        };
                        return [4 /*yield*/, apiClient.postResponse('/order/purchase-failed', apiPurchaseFailure, cancelTokenSource)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, paymentFailure];
                }
            });
        });
    };
    return OrderAPI;
}());
var cartController = new OrderAPI();
export default cartController;
